import React, {useContext} from 'react';

import {View, useWindowDimensions} from 'react-native';
import {AppCtx} from './configs/appContext';
import {BreakPoints} from './configs/util';
import {MicroFrontend} from '@voltmoney/platform';
import {ROUTE, ROUTE_MAP} from '@voltmoney/micro-frontend';
import {WidgetRegistry} from '@voltmoney/component';

const PartnerSignUpLogin = ({route}: any) => {
  console.warn('*** PartnerDashboard routing params', route.params);
  const {height, width} = useWindowDimensions();
  const AppContext = useContext(AppCtx);
  return (
    <AppCtx.Provider value={AppContext}>
      <View
        style={{
          height: width > BreakPoints.WEB ? height : '100%',
          width: '100%',
          flex: 1,
          flexDirection: 'column',
        }}>
        {/*<PartnerHeader />*/}
        {/*/!*@ts-ignore*!/*/}
        {/*<PartnerBody navigation={navigation} route={route} />*/}
        <MicroFrontend
          routeMap={ROUTE_MAP}
          routeCurrent={ROUTE.PARTNER_SIGNUP}
          widgetRegistry={WidgetRegistry}
          extraProps={{
            route: route,
          }}
          //@ts-ignore
          width={width}
          height={height}
          isPartnerPlatform={true}
        />
      </View>
    </AppCtx.Provider>
  );
};
export default PartnerSignUpLogin;
